import core, { View } from '@gin-betting/core';
import { createSelector, createStructuredSelector } from 'reselect';

import { useMemoSelector } from 'hooks';

const {
    entities: {
        selectors: {
            selectMatch,
            makeMatchSelector,
            makeTournamentSelector,
            selectPreviewTournamentIdFromMatch,
        },
    },
} = core;

interface Input {
    sportEventId: string;
    prevSportEventId: string | undefined;
}

interface Output {
    hasHeader: boolean;
    tournament: View.Tournament | null;
}

const useTournamentHeader = ({
    sportEventId,
    prevSportEventId,
}: Input): Output => {
    const { hasHeader, tournament } = useMemoSelector(makeSelectProps(), {
        matchId: sportEventId,
        prevMatchId: prevSportEventId,
    });

    return {
        hasHeader,
        tournament,
    };
};

export default useTournamentHeader;

const makeSelectProps = () => {
    const selectTournament = makeTournamentSelector({
        selectTournamentId: selectPreviewTournamentIdFromMatch,
    });

    const selectTournamentIdByPrevMatch = makeMatchSelector({
        propsToPick: ['tournament'],
        selectMatchId: (_, props: { prevMatchId: string }) => props.prevMatchId,
    });

    const selectHasHeader = createSelector(
        selectMatch,
        selectTournamentIdByPrevMatch,
        (match, prevMatch) =>
            !match || !prevMatch || match.tournament !== prevMatch.tournament
    );

    return createStructuredSelector({
        hasHeader: selectHasHeader,
        tournament: selectTournament,
    });
};
